/* Trade page behaviour (sections/ll-trade.liquid). Everything is scoped to the .tp root. */
(() => {
  const root = document.querySelector('.ll-tp');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // hero: dim the example invoice and pop the Everyday Low ticket
  setTimeout(() => { $('#tpWrap').classList.add('dim'); $('#tpTicket').classList.add('in'); }, 700);

  // steps band
  const total = +root.dataset.total || 0;
  const saveEl = $('#tpSave');
  const tabs = $$('.tab'), scenes = $$('.scene');
  let timer;
  function countUp(to, ms) {
    const t0 = performance.now();
    (function f(t) {
      const k = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - k, 3);
      saveEl.textContent = '$' + Math.round(to * e);
      if (k < 1) requestAnimationFrame(f);
    })(t0);
  }
  function show(i) {
    tabs.forEach((t, k) => t.classList.toggle('on', k === i));
    tabs[i].classList.remove('on'); void tabs[i].offsetWidth; tabs[i].classList.add('on');
    scenes.forEach((s, k) => s.classList.toggle('on', k === i));
    scenes[i].querySelectorAll('.prog i,.tick').forEach((x) => { x.style.animation = 'none'; void x.offsetWidth; x.style.animation = ''; });
    if (i === 1) {
      const rows = $$('#tpMini li');
      rows.forEach((l) => l.classList.remove('in'));
      rows.forEach((l, k) => setTimeout(() => l.classList.add('in'), 250 + k * 300));
      if (reduced) saveEl.textContent = '$' + total; else countUp(total, 1400);
    }
    clearTimeout(timer);
    timer = setTimeout(() => show((i + 1) % 3), 6000);
  }
  tabs.forEach((t, i) => t.addEventListener('click', () => show(i)));
  new IntersectionObserver(([e], o) => { if (e.isIntersecting) { show(0); o.disconnect(); } }, { threshold: .4 }).observe($('.band'));

  // order steppers
  $$('.tp-qty').forEach((q) => q.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    const em = q.querySelector('em');
    em.textContent = Math.max(0, +em.textContent + +b.dataset.step);
  }));

  // business / event choice
  const biz = $('#tpBiz');
  function forType(v) {
    $$('[data-for]').forEach((d) => {
      const on = d.dataset.for === v;
      d.hidden = !on;
      d.querySelectorAll('input,select').forEach((f) => { f.disabled = !on; });
    });
    biz.required = v === 'business';
  }
  $$('input[name="contact[for]"]').forEach((r) => r.addEventListener('change', () => forType(r.value)));
  forType('business');

  // invoice upload: hero button scrolls to the form and opens the same picker
  const cfg = JSON.parse(document.getElementById('tpCfg').textContent);
  const file = $('#tpInv'), link = $('#tpInvLink'), drop = file.closest('.drop');
  const dropTitle = drop.querySelector('b'), dropSub = drop.querySelector('span'), submit = $('#tpSubmit');
  const dropSubDefault = dropSub.textContent, dropTitleDefault = dropTitle.textContent;
  $('#tpHeroDrop').addEventListener('click', () => {
    $('#audit').scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    file.click();
  });
  file.addEventListener('change', async () => {
    link.value = '';
    drop.classList.remove('got');
    dropTitle.textContent = dropTitleDefault; dropSub.textContent = dropSubDefault;
    const f = file.files[0]; if (!f) return;
    if (f.size > 4 * 1024 * 1024) { dropSub.textContent = 'That file is over 4 MB. Please choose a smaller one.'; file.value = ''; return; }
    submit.disabled = true; dropSub.textContent = 'Uploading...';
    try {
      const r = await fetch(cfg.uploadUrl, { method: 'POST', headers: { 'content-type': f.type, 'x-filename': encodeURIComponent(f.name), 'x-captcha': await window.LLCaptcha(file.form) }, body: f });
      const j = await r.json(); if (!r.ok) throw new Error(j.error);
      link.value = j.url; drop.classList.add('got'); dropTitle.textContent = f.name;
      dropSub.textContent = "Uploaded. We'll price it line by line.";
    } catch (e) {
      dropSub.textContent = (e && e.message) || "Upload didn't work. You can still send the form and add a message instead.";
      file.value = '';
    }
    submit.disabled = false;
  });

  // phone: visible input has no name, submit "+64 " + number
  const form = $('#trade-form'), phone = $('#tpPhone'), phoneVal = $('#tpPhoneVal');
  window.LLCaptcha.mount(form); // visible tick box above the send button (assets/ll-enquiry.js)
  // Our own send (HTML team email + customer thank-you); Shopify's contact email is the fallback.
  let viaShopify = false;
  // capture phase on document: runs before Shopify's hCaptcha listener on contact forms, which would also post the form (double send)
  document.addEventListener('submit', async (ev) => {
    if (ev.target !== form) return;
    phoneVal.value = '+64 ' + phone.value.trim().replace(/^0/, '');
    if (viaShopify || !cfg.enquiryUrl) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    const fd = new FormData(form), get = (k) => (fd.get('contact[' + k + ']') || '').toString();
    const data = { website: (fd.get('website') || '').toString() };
    ['for', 'business', 'event', 'guests', 'name', 'phone', 'email', 'message', 'invoice_link'].forEach((k) => { data[k] = get(k); });
    submit.disabled = true;
    try {
      const r = await fetch(cfg.enquiryUrl, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ ...data, captcha: await window.LLCaptcha(form) }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) throw new Error(j.error || 'send');
      form.querySelector('.fields').hidden = true;
      const th = $('#tpThanks'); th.hidden = false;
      th.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    } catch (e) {
      viaShopify = true; submit.disabled = false;
      form.requestSubmit(); // fallback: Shopify contact email (with its captcha), nothing lost
    }
  }, true);

  // message pop-up
  const dlg = $('#tpMsgDlg'), txt = $('#tpMsgText'), val = $('#tpMsgVal'), tile = $('#tpMsgTile');
  const label = $('#tpMsgLabel'), prev = $('#tpMsgPrev'), count = $('#tpMsgCount');
  const labelDefault = label.textContent, prevDefault = prev.textContent;
  const updateCount = () => { count.textContent = txt.value.length + ' / 1000'; };
  tile.addEventListener('click', () => { txt.value = val.value; updateCount(); dlg.showModal(); setTimeout(() => txt.focus(), 60); });
  txt.addEventListener('input', updateCount);
  dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
  dlg.querySelector('form').addEventListener('submit', () => {
    const v = txt.value.trim();
    val.value = v;
    label.textContent = v ? 'Your message' : labelDefault;
    prev.textContent = v || prevDefault;
    tile.classList.toggle('has', !!v);
  });

  // after a successful send, bring the thank-you into view
  const thanks = $('#tpThanks');
  if (thanks && !thanks.hidden) thanks.scrollIntoView({ block: 'center' });
})();
